__turbopack_context__.v({
  "float": "compositions-module__JGDC3W__float",
  "line": "compositions-module__JGDC3W__line",
  "lineShort": "compositions-module__JGDC3W__lineShort",
  "scene": "compositions-module__JGDC3W__scene",
});
